import * as db from '../../db'
import _ from 'lodash'

export const RECEIVE_MENU = 'RECEIVE_MENU'
export const SET_HOTSPOT_CATEGORIES = "SET_HOTSPOT_CATEGORIES";
export const LOADING_MENU = 'LOADING_MENU'
export const LOADING_HOTSPOT_CATEGORIES = "LOADING_HOTSPOT_CATEGORIES";
export const RECEIVE_HOTSPOTS = 'RECEIVE_HOTSPOTS'

// initial state
const state = {
  loading: false,
  hotspotMenu: {},
  spots: [],
  icon: '',
}

// getters
const getters = {
  hotspotMenu: state => _.values(state.hotspotMenu),
  loading: state => state.loading,
  spots: state => _.values(state.spots),
  getIcon: state => state.icon,
}

// actions
const actions = {
  // getMenu ({ commit }) {
  //   commit(LOADING_MENU, true)
  //   db.menuSpots
  //     .once('value')
  //     .then(menu => {
  //       let menuItems = []
  //       const obj = menu.val()
  //       for (let key in obj) {
  //         menuItems.push({
  //           id: key,
  //           icon: obj[key].icon,
  //           title: obj[key].title,
  //           recommend: obj[key].recommend
  //         })
  //       }
  //       commit(RECEIVE_MENU, { menuItems })
  //     })
  //     .catch(error => {
  //       console.log(error)
  //     })
  //   commit(LOADING_MENU, false)
  // },
  getHotspotCategories({commit}){
     commit(LOADING_HOTSPOT_CATEGORIES, true)
      db.hotspotMenu
      .once('value')
      .then(spot => {
        let spots = []
        const obj = spot.val();
        for (let key in obj) {
          spots.push({
            id: key,
            icon: obj[key].icon,
            category: obj[key].category,
            title: obj[key].title,
            recommend: obj[key].recommend
          });
        }
        // console.log(spots)
        commit(SET_HOTSPOT_CATEGORIES, { spots });
      })
      .catch(error => {
        console.log(error)
      })
    commit(LOADING_HOTSPOT_CATEGORIES, false);
  }
}

// mutations
const mutations = {
  [RECEIVE_MENU](state, { menuItems }) {
    state.hotspotMenu = menuItems;
  },
  [LOADING_MENU](state, value) {
    state.loading = value;
  },
  [LOADING_HOTSPOT_CATEGORIES](state, value) {
    state.loading = value;
  },
  // [RECEIVE_HOTSPOTS](state, { hotspots }) {
  //   state.hotspots = hotspots;
  // },
  [SET_HOTSPOT_CATEGORIES](state, { spots }) {
    state.spots = spots;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/hotspot.js